// Browser-native sharing for the Promote Event "Share…" button. Uses the Web Share API
// (navigator.share) where available -- the browser/device picks the destinations, so
// there is no custom dialog and no per-network integrations. Where it is unavailable,
// fall back to copying the public URL via the existing ClipboardJS helper, with the same
// "Copied!" confirmation the Copy button shows.
const WebShare = {
  start() {
    const canShare = typeof navigator !== 'undefined' && typeof navigator.share === 'function';
    $('[data-web-share]').each(function () {
      const $btn = $(this);
      if (canShare) {
        $btn.on('click', (e) => {
          e.preventDefault();
          navigator
            .share({
              title: $btn.data('shareTitle'),
              text: $btn.data('shareText'),
              url: $btn.data('shareUrl'),
            })
            // The user dismissing the share sheet rejects with AbortError -> do nothing.
            .catch(() => {});
        });
      } else {
        // No Web Share: hand the button to the already-initialised ClipboardJS helper
        // (it delegates on [data-clipboard-text]) so a click copies the URL and shows
        // the same "Copied!" tooltip as the Copy button.
        $btn.attr('data-clipboard-text', $btn.data('shareUrl'));
        $btn.attr('data-tooltip', $btn.data('shareText') || '');
        $btn.addClass('tooltip tooltip--top');
      }
    });
  },
};

export default WebShare;
